import { MenuState } from '@msdk/definitions'
import { atom } from 'recoil'

const INITIAL_MENU_STATE: MenuState = {
  isOpen: false,
}

export const $menuState = atom<MenuState>({
  key: 'menuState',
  default: INITIAL_MENU_STATE,
})
